import PropTypes from 'prop-types'

import Fade from '@mui/material/Fade'
import LinearProgressMui from '@mui/material/LinearProgress'

LinearProgress.propTypes = {
  /** Will be displayed if true */
  loading: PropTypes.bool,

  /** Color of linear progress */
  color: PropTypes.string,

  /** Can pass mui sx style */
  sx: PropTypes.object,
}

export default function LinearProgress({ loading = false, color, sx = {} }) {
  return (
    <Fade in={loading} timeout={500}>
      <LinearProgressMui sx={[{ position: 'absolute', width: '100%', zIndex: 1, borderRadius: 0 }, sx]} color={color} />
    </Fade>
  )
}
